import { useState } from "react";
import { Camera, ZoomIn } from "lucide-react";
import { StorageImage } from "@/components/StorageImage";

interface ProofPhotoSectionProps {
  bucket: string;
  storedValue: string | null;
  label: string;
  colorClass: string; // e.g. "blue", "teal", "green"
  onPreview: (bucket: string, path: string, title: string) => void;
}

const colorMap: Record<string, { bg: string; border: string; text: string }> = {
  blue: { bg: "bg-blue-500/5", border: "border-blue-500/20", text: "text-blue-700" },
  teal: { bg: "bg-teal-500/5", border: "border-teal-500/20", text: "text-teal-700" },
  green: { bg: "bg-green-500/5", border: "border-green-500/20", text: "text-green-700" },
};

export const ProofPhotoSection = ({ bucket, storedValue, label, colorClass, onPreview }: ProofPhotoSectionProps) => {
  const [hidden, setHidden] = useState(false);

  if (!storedValue || hidden) return null;

  const colors = colorMap[colorClass] || colorMap.blue;

  return (
    <div className={`p-4 ${colors.bg} border ${colors.border} rounded-lg`}>
      <p className={`text-sm font-medium ${colors.text} mb-3 flex items-center gap-2`}>
        <Camera className="w-4 h-4" />
        {label}
      </p>
      <div
        className="relative w-full max-w-xs cursor-pointer group rounded-lg overflow-hidden border"
        onClick={() => onPreview(bucket, storedValue, label)}
      >
        <StorageImage
          bucket={bucket}
          storedValue={storedValue}
          alt={label}
          className="w-full h-48 object-cover"
          onLoadError={() => setHidden(true)}
        />
        <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
          <ZoomIn className="h-6 w-6 text-white" />
        </div>
      </div>
    </div>
  );
};
